/**
 * @desc 更新回传装箱信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationMaster.updateBoxFlag.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/updateBoxFlag`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
